import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIService } from './api.service';
import { ReturnObject } from '../model/returnobject';

@Injectable({
    providedIn: 'root'
})
export class ConsultantService {

    constructor(private api: APIService){
    }

    GetUnitNumbers(): Observable<ReturnObject<string[]>> {
        return this.api.getAPI(`consultant/unitnumbers`);
    }
}
